import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observer } from 'mobx-react'
import ReactTooltip from 'react-tooltip'

@observer
class BasePage extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    type: PropTypes.string,
  }

  render() {

    const { /* type,*/ children } = this.props

    return (
      <main className="container-fluid vertical content">
        <ReactTooltip
          className="base-tooltip info-tooltip"
          html
          isCapture
          multiline
          showDelay={500}
        />
        {children}
      </main>
    )
  }
}

export { BasePage as default }



// WEBPACK FOOTER //
// ./src/frontend/base/components/BasePage.js